import React, { useState, useEffect } from 'react';

const TrueOrFalseQuestion = ({ event, onCorrect, onWrong }) => {
  const [statementYear, setStatementYear] = useState(event.year);
  const [isTrue, setIsTrue] = useState(true);

  useEffect(() => {
    if (Math.random() < 0.5) {
      setIsTrue(false);
      setStatementYear(event.year + (Math.random() > 0.5 ? 10 : -10));
    }
  }, [event]);

  const handleChoice = (choice) => {
    if (choice === (isTrue ? 'true' : 'false')) {
      onCorrect();
    } else {
      onWrong();
    }
  };

  return (
    <div className="text-center">
      <h3 className="text-lg font-bold text-blue-300 mb-4">
        "{event.title}" happened in {statementYear}.
      </h3>
      <div className="flex flex-col md:flex-row gap-6 justify-center">
        <button
          onClick={() => handleChoice('true')}
          className="bg-green-700 hover:bg-green-800 text-white px-6 py-3 rounded-lg font-semibold"
        >
          ✅ True
        </button>
        <button
          onClick={() => handleChoice('false')}
          className="bg-red-700 hover:bg-red-800 text-white px-6 py-3 rounded-lg font-semibold"
        >
          ❌ False
        </button>
      </div>
    </div>
  );
};

export default TrueOrFalseQuestion;
